import LegalLayout from "./LegalLayout";
import SeoHead from "@/components/SeoHead";

export default function RefundPolicy() {
  return (
    <LegalLayout title="Refund Policy" updated="May 2, 2026">
      <SeoHead title="Refund Policy" />
      <p>
        This Refund Policy applies to purchases of StoreSEO AI subscriptions and services operated
        by <strong>Storeseoai Team</strong>.
      </p>

      <h2>30-Day Money-Back Guarantee</h2>
      <p>
        We offer a <strong>30-day money-back guarantee</strong>. If you are not satisfied with your
        purchase, you may request a full refund within <strong>30 days</strong> of your order date.
      </p>

      <h2>How to Request a Refund</h2>
      <p>
        Refunds are processed by our payment provider, <strong>Paddle</strong>, which acts as the
        Merchant of Record for all purchases. To request a refund:
      </p>
      <ul>
        <li>
          Visit <a href="https://paddle.net" target="_blank" rel="noreferrer">paddle.net</a> and
          locate your order using the email address you used at checkout, or
        </li>
        <li>
          Email our support team at <a href="mailto:storeseoai@gmail.com">storeseoai@gmail.com</a>{" "}
          with your order details, and we will help you process the refund through Paddle.
        </li>
      </ul>

      <h2>Subscription Cancellations</h2>
      <p>
        You may cancel your subscription at any time from your account Settings. After cancellation,
        you will retain access until the end of the current billing period and will not be charged
        again.
      </p>

      <h2>Questions</h2>
      <p>
        For any questions about refunds or billing, contact us at{" "}
        <a href="mailto:storeseoai@gmail.com">storeseoai@gmail.com</a>.
      </p>
    </LegalLayout>
  );
}
